import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PiNotePencil, PiTrash } from 'react-icons/pi';
import { tagService } from '../../../services/tags.service';
import IconButton from '../../UI/IconButton/IconButton';
import TagEditForm from '../TagEditForm/TagEditForm';
import ConfirmModal from '../../UI/ConfirmModal/ConfirmModal';
import PermissionChecker from '../../UI/PermissionChecker/PermissionChecker';
import { PERMISSIONS } from '../../../shared/permission';
import { toast } from 'react-toastify';
import styles from './TagActionsCell.module.css';


function TagActionsCell({ params, onSuccess }) {
    const { t } = useTranslation('common');
    const { t: tValidation } = useTranslation('validation');
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);

    const handleEdit = () => {
        setIsEditModalOpen(true);
    };

    const handleDeleteClick = () => {
        setIsDeleteModalOpen(true);
    };

    const handleConfirmDelete = async () => {
        setIsDeleting(true);
        try {
            await tagService.deleteTag(params.row.id);
            toast.success(tValidation('tag_deleted_successfully'));
            if (onSuccess) {
                onSuccess();
            }
            setIsDeleteModalOpen(false);
        } catch (error) {
            console.error(error);
            toast.error(tValidation(error?.payload?.error || 'failed_to_delete_tag'));
        } finally {
            setIsDeleting(false);
        }
    };

    return (
        <div className={styles.container}>
            <PermissionChecker permissions={[PERMISSIONS.TAGS.EDIT]}>
                <IconButton
                    onClick={handleEdit}
                    variant="ghost"
                    size="small"
                    title={t('tags.edit')}
                >
                    <PiNotePencil />
                </IconButton>
            </PermissionChecker>
            <PermissionChecker permissions={[PERMISSIONS.TAGS.DELETE]}>
                <IconButton
                    onClick={handleDeleteClick}
                    variant="ghost"
                    size="small"
                    title={t('tags.delete')}
                    disabled={isDeleting}
                >
                    <PiTrash />
                </IconButton>
            </PermissionChecker>

            <TagEditForm
                isOpen={isEditModalOpen}
                onClose={() => setIsEditModalOpen(false)}
                onSuccess={onSuccess}
                tagId={params.row.id}
                initialData={{
                    code: params.row.code,
                    name: params.row.name,
                }}
            />

            <ConfirmModal
                isOpen={isDeleteModalOpen}
                onClose={() => setIsDeleteModalOpen(false)}
                onConfirm={handleConfirmDelete}
                title={t('tags.delete_confirm_title')}
                message={t('tags.delete_confirm_message', { name: params.row.name })}
                confirmText={t('tags.delete')}
                cancelText={t('tags.cancel')}
                isLoading={isDeleting}
            />
        </div>
    );
}

export default TagActionsCell;
